import CampaignPlanningConfirmationBillboardListItem from "./CampaignPlanningConfirmationBillboardListItem";
import { sanitizeHtml } from "../../../utils/Utils";
import Billboards from "../../../libs/API/Billboards";

class CampaignPlanningConfirmationBillboardList {
    constructor() {
        this.main = document.getElementById('campaign_planning_confirmation_billboard_list');

        this._holderItemsDigital = this.main.querySelector('.holder_items_digital');
        this._holderItemsStatic = this.main.querySelector('.holder_items_static');

        this._containerStatic = this.main.querySelector('.billboards-list--static');
        this._containerDigital = this.main.querySelector('.billboards-list--digital');

        this._brandCategoryOrBrandLabel = this.main.querySelector('.brand_category_or_brand_label');
        this._items = [];

    }

    set(items, brand = null, brandCategory = null) {
        this._holderItemsDigital.innerHTML = '';
        this._holderItemsStatic.innerHTML = '';
        this._holderItemsDigital.closest('table').querySelectorAll('.package_holder').forEach((holder) => {
            holder.parentElement.removeChild(holder);
            const separator = this._holderItemsDigital.closest('table').querySelector(`.line[data-package-id="${holder.dataset.packageId}"]`);
            separator.parentElement.removeChild(separator);
        });

        this._items = [];

        if (items.length > 0) {
            document.body.classList.remove('shopping-cart-empty');
            this.main.classList.remove('card-box__section--empty-cart');

            Array.from(this.main.querySelectorAll('.counter_label_digital')).forEach((label) => {
                let countDigital = 0;
                items.forEach(element => {
                    if (element.format.name == 'Digital') countDigital += 1;
                });
                label.innerHTML = `(${countDigital})`;

                if (countDigital == 0) {
                    this._containerDigital.classList.add('d-none');
                    this.main.dispatchEvent(new CustomEvent('AD_BUILDER_MODULE_HIDE'));
                }
            })
            Array.from(this.main.querySelectorAll('.counter_label_static')).forEach((label) => {
                let countStatic = 0;
                items.forEach(element => {
                    if ([Billboards.FORMAT_STATIC, Billboards.FORMAT_OTHER_MEDIA].includes(Number(element.format.id))) {
                        countStatic += 1;
                    }
                });
                label.innerHTML = `(${countStatic})`;
                if (countStatic == 0) this._containerStatic.classList.add('d-none');
            })

            if (brand != null) {
                this._brandCategoryOrBrandLabel.querySelector('.type').innerHTML = 'brand';
                this._brandCategoryOrBrandLabel.querySelector('.name').innerHTML = brand.name;
            } else if (brandCategory != null) {
                this._brandCategoryOrBrandLabel.querySelector('.type').innerHTML = 'category';
                this._brandCategoryOrBrandLabel.querySelector('.name').innerHTML = brandCategory.name;
            }

            items.forEach((itemData) => {
                let item = new CampaignPlanningConfirmationBillboardListItem(itemData);
                const table = document.querySelector('.holder_items_digital').closest('table');

                if (itemData.package) {
                    let packageHolder = table.querySelector(`.package_holder[data-package-id="${itemData.package.id}"]`);
                    if (!packageHolder) {
                        const tbodyElement = document.createElement('table');
                        const htmlString = `<tbody class="table__tbody table__tbody--items-not-clickable package_holder mt-3 mb-1" data-package-id="${itemData.package.id}" data-package-name="${itemData.package.name}">
                            <tr class="table__tr">
                                <td class="table__td" colspan="4">
                                    <div class="row">
                                        <div class="col-10">
                                            <h4 class="heading heading--size-9 weight-550">${sanitizeHtml(itemData.package.name)}</h4>
                                        </div>
                                        <div class="col-2 text-right">
                                            <span class="delete_package_btn"><i class="material-icons material-icons--type-outlined material-icons--size-3">delete</i></span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>`;

                        tbodyElement.innerHTML = htmlString.trim();
                        packageHolder = tbodyElement.firstChild;
                        packageHolder.querySelector('.delete_package_btn').addEventListener('click', this._onClickDeletePackageBtn.bind(this));
                        table.insertAdjacentElement('afterbegin', packageHolder);

                        const separator = document.createElement('hr');
                        separator.classList.add('line', 'mb-3', 'd-lg-block', 'd-none');
                        separator.setAttribute('data-package-id', itemData.package.id);
                        packageHolder.after(separator);
                    }
                    packageHolder.appendChild(item.main);
                } else {
                    if (itemData.format.name == 'Digital') {
                        this._holderItemsDigital.append(item.main);
                    } else {
                        this._holderItemsStatic.append(item.main);
                    }
                }
                this._items.push(item);
            })

        } else {
            this.main.classList.add('card-box__section--empty-cart');
            document.body.classList.add('shopping-cart-empty');
        }

    }

    _onClickDeletePackageBtn(e) {
        const packageId = e.target.closest('.package_holder').dataset.packageId;

        document.getElementById('shopping_cart').dispatchEvent(new CustomEvent('SHOPPING_CART_PACKAGE_REMOVE', {
            bubbles: true,
            detail: {
                package_id: packageId,
            }
        }));
    }
}

export default CampaignPlanningConfirmationBillboardList;